import { IdNameModel } from "../ndm/models/idName.model";

export const VALIDATE_EMAIL_ADDRESS = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

export const WholeSalerTypes = [
    { text: 'Independant', value: "I" },
    { text: 'Multiple', value: "M" }
];

export const Days: IdNameModel[] = [
    { name: 'Sunday', id: 0 },
    { name: 'Monday', id: 1},
    { name: 'Tuesday', id: 2 },
    { name: 'Wednesday', id: 3 },
    { name: 'Thursday', id: 4 },
    { name: 'Friday', id: 5 },
    { name: 'Saturday', id: 6 }
];

export const VolumeDays: IdNameModel[] = [
    { name: 'Sunday', id: 1 },
    { name: 'Monday', id: 2},
    { name: 'Tuesday', id: 3 },
    { name: 'Wednesday', id: 4 },
    { name: 'Thursday', id: 5 },
    { name: 'Friday', id: 6 },
    { name: 'Saturday', id: 7 }
];

export const Levels: IdNameModel[] = [
    { name: 'Visitor ', id: 0 },
    { name: 'Authorised User ', id: 16 },
    { name: 'Authorised User with Audit Log Access', id: 48},
    { name: 'Authorised User with Manual Data Entry', id: 112 },
    { name: 'Administrator', id: 255 }
];

export const ParentTypes: any[] = [
    { name: 'Unaffiliated ', id: 'U' },
    { name: 'Branch ', id: 'B' },
    { name: 'Wholesaler ', id: 'W' },
    { name: 'System Owner ', id: 'O' }
];